import { Card } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

interface ProductCardSkeletonProps {
  viewMode?: 'grid' | 'list' | 'compact'
  flushImage?: boolean
}

export function ProductCardSkeleton({ viewMode = 'grid', flushImage = false }: ProductCardSkeletonProps) {
  const cardPaddingClass = flushImage ? 'p-0' : ''
  const contentPaddingClass = flushImage ? 'px-3 pb-3 pt-2' : 'p-3'
  const contentGapClass = flushImage ? 'gap-1.5' : 'gap-2'
  const imageSkeleton = flushImage ? (
    <div className="aspect-square w-full overflow-hidden bg-[#fafafa] p-2">
      <Skeleton className="h-full w-full" />
    </div>
  ) : (
    <Skeleton className="aspect-square w-full" />
  )

  if (viewMode === 'grid') {
    return (
      <Card className={`flex h-full flex-col overflow-hidden border border-border/60 bg-white gap-0 ${cardPaddingClass}`}>
        {imageSkeleton}
        <div className={`flex flex-1 flex-col ${contentPaddingClass} ${contentGapClass}`}>
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <div className="mt-auto space-y-2">
            <Skeleton className="h-3 w-16" />
            <div className="rounded-lg border border-border/40 px-2.5 py-2">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="mt-2 h-8 w-28" />
            </div>
          </div>
        </div>
      </Card>
    )
  }

  if (viewMode === 'compact') {
    return (
      <Card className="flex gap-3 p-3 border border-border/60 bg-white">
        <Skeleton className="h-16 w-16 shrink-0" />
        <div className="flex flex-1 items-center gap-3 min-w-0">
          <div className="flex-1 min-w-0 space-y-2">
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-2 w-24" />
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Skeleton className="h-5 w-16" />
            <Skeleton className="h-5 w-16" />
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-7 w-7" />
          </div>
        </div>
      </Card>
    )
  }

  return (
    <Card className="flex gap-4 p-4 border border-border/60 bg-white">
      <Skeleton className="h-32 w-32 shrink-0" />
      <div className="flex flex-1 flex-col gap-3">
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-48" />
          <div className="flex gap-1.5 mt-2">
            <Skeleton className="h-5 w-16" />
            <Skeleton className="h-5 w-20" />
            <Skeleton className="h-5 w-12" />
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-1">
            <Skeleton className="h-3 w-16" />
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-3 w-32" />
          </div>
          <Skeleton className="h-10 w-32" />
        </div>
      </div>
    </Card>
  )
}
